import { render, staticRenderFns } from "./employeeRegistration.vue?vue&type=template&id=4af62398&scoped=true&"
import script from "./employeeRegistration.vue?vue&type=script&lang=js&"
export * from "./employeeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./employeeRegistration.vue?vue&type=style&index=0&id=4af62398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af62398",
  null
  
)

export default component.exports